<template lang="pug">
    div ( v-if="noSecret" ) Enter secret
        input#secret_input
        input#key_input
        button ( v-on:click="updateSecretFromInput" )
</template>

<script>
    import { ttcaller } from '~api';
    import { ecc, encrypt, decrypt, codec } from 'sjcl-all';

    export default {
        data() {
            return {
                noSecret: this.noSecret,
            };
        },
        async created() {
            var hasSecret = false;
            var priKey = window.localStorage.getItem('privateKey');
            if (priKey == null) {
                var keys = ecc.elGamal.generateKeys(384, 1);

                this.pubKeyHex = keys.pub.serialize().point;
                ttcaller.uploadPublicKey(this.pubKeyHex);

                window.localStorage.setItem('publicKey', keys.pub);
                window.localStorage.setItem('privateKey', keys.sec);
            } else {
                this.pubKeyHex = window.localStorage.getItem('publicKey');
                var secret = this.getSecret();
                if (secret != undefined) {
                    hasSecret = true;
                    // Check for non-synced clients:
                    var encryptedSecrets = this.encryptAllSecrets(secret);
                    if (encryptedSecrets != {}) {
                        ttcaller.uploadEncryptedSecrets(encryptedSecrets);
                    }
                }
            }

            this.noSecret = !hasSecret;
        },
        methods: {
            getSecret() {
                var priKey = window.localStorage.getItem('privateKey');
                var encSecret = ttcaller.getEncryptedSecretByPublicKey(
                    this.pubKeyHex
                );

                return decrypt(priKey, encSecret);
            },
            getToken() {
                // eslint-disable-next-line no-unused-vars
                var secret = this.getSecret();
                // $api.post(); // Follow TT API
                // FOR TESTING PURPOSES ONLY:
            },
            encryptAllSecrets(secret) {
                var other_publics = ttcaller.getPublicKeysWithoutSecret(
                    self.pubKeyHex
                );
                var encryptedSecrets = {};
                for (var i in other_publics) {
                    var keyHex = other_publics[i];
                    var pubKey = ecc.elGamal.publicKey(
                        ecc.curves.c384,
                        ecc.curves.c384.field.fromBits(codec.hex.toBits(keyHex))
                    );

                    encryptedSecrets[keyHex] = encrypt(pubKey, secret);
                }
                return encryptedSecrets;
            },
            updateSecretFromInput() {
                var element = document.getElementById('secret_input');
                var secret = element.value;
                var encryptedSecrets = this.encryptAllSecrets(secret);
                ttcaller.updateEncryptedSecrets(encryptedSecrets);
            },
        },
    };
</script>
